<template>
    <div class="table-container">
        <vue-table2
            :csrf="csrf"
            :title="title"
            :is-searchable="true"
            :is-orderable="false"
            :data-provider="dataProvider"
            :buttons="buttons"
            :actions="actions"
            @deleted="handleActionResponse"
            custom-no-information-message="All areas were accessed."
            ref="table">
        </vue-table2>

        <no-access-area-modal :open="isModalOpen"
                   :register-id="registerId"
                   :selected-item="selectedItem"
                   @error="handleErrorResponse"
                   @created="handleActionResponse"
                   @updated="handleActionResponse"
                   @closed="closeModal()" />

        <session-alert :success="alerts.success"
                       :error="alerts.error" form_error="false"></session-alert>
    </div>
</template>

<script>
import VueTable2 from '../components/Table2';

export default {
    name: 'NoAccessAreaTable',

    props: {
        title: {
            type: String,
            required: true
        },
        isSearchable: {
            type: Boolean,
            default: false
        },
        isSortable: {
            type: Boolean,
            default: false
        },
        registerId: {
            type: String,
            required: true
        },
        csrf: {
            type: String,
            required: true
        }
    },

    components: {
        VueTable2
    },

    data() {
        return {
            isDeleteModalOpen: false,
            isModalOpen: false,
            selectedItem: null,
            buttons: [
                {
                    text: 'Add New No Access Area',
                    type: 'button',
                    action: () => { this.handleAddNewClick() }
                }
            ],
            actions: [
                {
                    text: 'Edit',
                    type: 'edit',
                    action: this.handleEditClick,
                    class: 'text-uknar-primary hover:text-uknar-primary font-medium'
                },
                {
                    text: 'Delete',
                    type: 'delete',
                    class: 'text-rose-600 hover:text-rose-900 font-medium'
                }
            ],
            alerts: {
                success: { message: null },
                error: { message: null }
            }
        }
    },

    methods: {
        handleErrorResponse(error) {
            this.alerts = {
                success: { message: null },
                error: { message: error.response?.data?.message ?? error.message }
            }
        },

        handleActionResponse(response) {
            this.alerts = {
                success: { message: response.data?.success ? response.data?.message : null },
                error: { message: !response.data?.success ? response.data?.message : null }
            }

            if (response.data?.message) {
                this.$refs.table.loadData();
                this.closeModal();
            }
        },

        handleEditClick(item) {
            this.selectedItem = item;
            this.openModal();
        },

        openModal() {
            this.isModalOpen = true;
        },

        closeModal() {
            this.isModalOpen = false;
            this.selectedItem = null;
        },

        handleAddNewClick() {
            this.selectedItem = null;
            this.openModal();
        },

        dataProvider(page, keyword, { orderValue, orderDirection }) {
            const parameters = {
                page: page,
                search: keyword,
                order: orderValue,
                order_direction: orderDirection
            }

            return window.axios.get(route('ajax.register.noaccessarea', this.registerId), { params: parameters })
        }
    }
}
</script>
